/**
 * NOTE: this is an autogenerated file! do not change!
 * to change feature imports, edit /apps/<name>/shared/features.json!
 */

import {CoreBaseFeature} from "@common/core/feature";
import {MessagesBaseFeature} from "@common/messages/feature";
import {DocumentationBaseFeature} from "@common/documentation/feature";
import {MailBaseFeature} from "@common/mail/feature";
import {ConsoleBaseFeature} from "@common/console/feature";
import {AbilitiesBaseFeature} from "@common/abilities/feature";
import {MediaBaseFeature} from "@common/media/feature";
import {CloudinaryBaseFeature} from "@common/cloudinary/feature";
import {FaqBaseFeature} from "@common/faq/feature";
import {FeedbackBaseFeature} from "@common/feedback/feature";
import {MailerBaseFeature} from "@common/mailer/feature";
import {MaintenanceBaseFeature} from "@common/maintenance/feature";
import {StatisticsBaseFeature} from "@common/statistics/feature";
import {CmsBaseFeature} from "@common/cms/feature";
import {UsersBaseFeature} from "@common/users/feature";
import {AccessibilityBaseFeature} from "@common/accessibility/feature";
import {HealthInsurancesBaseFeature} from "@common/health-insurances/feature";
import {TaskSchedulerBaseFeature} from "@common/task-scheduler/feature";
import {AuthStrategyCredentialsBaseFeature} from "@common/auth-strategy-credentials/feature";
import {TrackingBaseFeature} from "@common/tracking/feature";
import {MpfContactBaseFeature} from "@mpf/contact/feature";
import {MembershipBaseFeature} from "@common/membership/feature";
import {MembershipPluginsLegacyBaseFeature} from "@pflegetheke/membership-plugins-legacy/feature";
import {MembershipPluginsInsuranceBaseFeature} from "@pflegetheke/membership-plugins-insurance/feature";
import {PflegethekeQuestionsBaseFeature} from "@pflegetheke/questions/feature";
import {PflegethekeBillingBaseFeature} from "@pflegetheke/billing/feature";
import {PflegethekeUsersBaseFeature} from "@pflegetheke/users/feature";
import {PflegethekeAppBaseFeature} from "@pflegetheke/app/feature";
import {CoreFrontendSharedFeature} from "@common/core/frontend-shared";
import {CoreFrontendManagementFeature} from "@common/core/frontend-management";
import {MessagesFrontendFeature} from "@common/messages/frontend";
import {ConsoleFrontendSharedFeature} from "@common/console/frontend-shared";
import {MediaFrontendFeature} from "@common/media/frontend";
import {FaqFrontendFeature} from "@common/faq/frontend";
import {MaintenanceFrontendFeature} from "@common/maintenance/frontend";
import {UsersFrontendFeature} from "@common/users/frontend";
import {UsersFrontendManagementFeature} from "@common/users/frontend-management";
import {AccessibilityFrontendFeature} from "@common/accessibility/frontend";
import {AuthStrategyCredentialsFrontendFeature} from "@common/auth-strategy-credentials/frontend";
import {TrackingFrontendFeature} from "@common/tracking/frontend";
import {MpfContactFrontendFeature} from "@mpf/contact/frontend";
import {MembershipFrontendFeature} from "@common/membership/frontend";
import {PflegethekeQuestionsFrontendFeature} from "@pflegetheke/questions/frontend";
import {PflegethekeAppFrontendFeature} from "@pflegetheke/app/frontend";
import {clientCacheDevToolProvider} from "@common/core/frontend-shared";
import {DevToolProviderToken} from "@core/shared/dev-tools";
import {modelMetadataDevToolDefinition} from "@common/core/frontend-shared";
import {storeInspectorDevToolDefinition} from "@common/core/frontend-shared";
import {MediaAssetProviderCloudinaryFrontend} from "@common/cloudinary/frontend-shared";
import {MEDIA_ASSET_PROVIDER_TOKEN} from "@common/media/shared";
import {AccessUserPluginFrontend} from "@common/users/frontend-shared";
import {ACCESS_SERVICE_PLUGIN_TOKEN} from "@core/shared/access";
import {AccessMembershipFrontendPlugin} from "@common/membership/frontend";
import {PaymentFrontendMembershipPlugin} from "@pflegetheke/membership-plugins-legacy/frontend-shared";
import {MEMBERSHIP_PLUGINS_TOKEN} from "@common/membership/shared";
import {InsuranceFrontendMembershipPlugin} from "@pflegetheke/membership-plugins-legacy/frontend-shared";
import {PrivateInsuranceFrontendMembershipPlugin} from "@pflegetheke/membership-plugins-legacy/frontend-shared";
import {InsuranceSimpleFrontendMembershipPlugin} from "@pflegetheke/membership-plugins-insurance/frontend-shared";
import {Insurance2025FrontendMembershipPlugin} from "@pflegetheke/membership-plugins-insurance/frontend-shared";
import {PrivateInsuranceSimpleFrontendMembershipPlugin} from "@pflegetheke/membership-plugins-insurance/frontend-shared";
import { CoreFeatureModule } from "@core/frontend-shared";

export default [
	// include base feature info
	CoreFeatureModule.forRoot([
		CoreBaseFeature,
		MessagesBaseFeature,
		DocumentationBaseFeature,
		MailBaseFeature,
		ConsoleBaseFeature,
		AbilitiesBaseFeature,
		MediaBaseFeature,
		CloudinaryBaseFeature,
		FaqBaseFeature,
		FeedbackBaseFeature,
		MailerBaseFeature,
		MaintenanceBaseFeature,
		StatisticsBaseFeature,
		CmsBaseFeature,
		UsersBaseFeature,
		AccessibilityBaseFeature,
		HealthInsurancesBaseFeature,
		TaskSchedulerBaseFeature,
		AuthStrategyCredentialsBaseFeature,
		TrackingBaseFeature,
		MpfContactBaseFeature,
		MembershipBaseFeature,
		MembershipPluginsLegacyBaseFeature,
		MembershipPluginsInsuranceBaseFeature,
		PflegethekeQuestionsBaseFeature,
		PflegethekeBillingBaseFeature,
		PflegethekeUsersBaseFeature,
		PflegethekeAppBaseFeature
	],[
		{token:DevToolProviderToken, value:clientCacheDevToolProvider},
		{token:DevToolProviderToken, value:modelMetadataDevToolDefinition},
		{token:DevToolProviderToken, value:storeInspectorDevToolDefinition},
		{token:MEDIA_ASSET_PROVIDER_TOKEN, value:MediaAssetProviderCloudinaryFrontend},
		{token:ACCESS_SERVICE_PLUGIN_TOKEN, value:AccessUserPluginFrontend},
		{token:ACCESS_SERVICE_PLUGIN_TOKEN, value:AccessMembershipFrontendPlugin},
		{token:MEMBERSHIP_PLUGINS_TOKEN, value:PaymentFrontendMembershipPlugin},
		{token:MEMBERSHIP_PLUGINS_TOKEN, value:InsuranceFrontendMembershipPlugin},
		{token:MEMBERSHIP_PLUGINS_TOKEN, value:PrivateInsuranceFrontendMembershipPlugin},
		{token:MEMBERSHIP_PLUGINS_TOKEN, value:InsuranceSimpleFrontendMembershipPlugin},
		{token:MEMBERSHIP_PLUGINS_TOKEN, value:Insurance2025FrontendMembershipPlugin},
		{token:MEMBERSHIP_PLUGINS_TOKEN, value:PrivateInsuranceSimpleFrontendMembershipPlugin}
	]),

	// load feature plugins for this platform
	CoreFrontendSharedFeature,
	CoreFrontendManagementFeature,
	MessagesFrontendFeature,
	ConsoleFrontendSharedFeature,
	MediaFrontendFeature,
	FaqFrontendFeature,
	MaintenanceFrontendFeature,
	UsersFrontendFeature,
	UsersFrontendManagementFeature,
	AccessibilityFrontendFeature,
	AuthStrategyCredentialsFrontendFeature,
	TrackingFrontendFeature,
	MpfContactFrontendFeature,
	MembershipFrontendFeature,
	PflegethekeQuestionsFrontendFeature,
	PflegethekeAppFrontendFeature
] as const;

